import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Link2, Search } from "lucide-react";
import api from "@/lib/api";
import { fmtEur } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { partnerName } from "./crmConst";

export const LinkProjectDialog = ({ open, onOpenChange, client, partners, onLinked }) => {
  const [q, setQ] = useState("");
  const [list, setList] = useState([]);
  const [busy, setBusy] = useState(null);
  const search = () => api.get("/crm/projects/search", { params: { q } }).then((r) => setList(r.data));
  useEffect(() => {
    if (!open) return undefined;
    const t = setTimeout(search, 250);
    return () => clearTimeout(t);
  }, [q, open]); // eslint-disable-line react-hooks/exhaustive-deps
  const link = async (p) => {
    if (p.client_id && p.client_id !== client.id && !window.confirm(`Ce projet est rattaché à « ${p.client_name} ». Le déplacer vers « ${client.company} » ?`)) return;
    setBusy(p.id);
    try {
      await api.post(`/crm/clients/${client.id}/projects/${p.id}`);
      toast.success("Projet rattaché");
      await search();
      onLinked();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Rattachement impossible");
    } finally {
      setBusy(null);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl" data-testid="crm-link-dialog">
        <DialogHeader>
          <DialogTitle>Rattacher un projet à {client?.company}</DialogTitle>
          <DialogDescription>Recherchez parmi tous les projets (nom du projet ou client saisi).</DialogDescription>
        </DialogHeader>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" placeholder="Rechercher un projet…" data-testid="crm-link-search" />
        </div>
        <div className="max-h-96 overflow-y-auto space-y-1.5">
          {list.map((p) => {
            const here = p.client_id === client?.id;
            return (
              <div key={p.id} className="flex items-center gap-3 rounded-lg border border-border px-3 py-2" data-testid={`crm-link-row-${p.id}`}>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-sm truncate">{p.name}</div>
                  <div className="text-xs text-muted-foreground truncate">
                    {partnerName(partners, p.partner_id)} · {p.user_name || "—"} · {p.status}{p.client_name ? ` · client : ${p.client_name}` : " · sans client"}
                  </div>
                </div>
                <span className="metric text-sm font-semibold text-genis">{fmtEur(p.result?.total_prime)}</span>
                <Button size="sm" variant={here ? "secondary" : "outline"} disabled={here || busy === p.id} onClick={() => link(p)} data-testid={`crm-link-btn-${p.id}`}>
                  <Link2 className="h-3.5 w-3.5 mr-1" /> {here ? "Déjà lié" : "Rattacher"}
                </Button>
              </div>
            );
          })}
          {!list.length && <p className="text-sm text-muted-foreground py-6 text-center">Aucun projet trouvé.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
